import React, { useState, useEffect } from 'react';
import FormField from './formField';
import DropArea from './formArea';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import FieldEditor from './fieldEditor';
import { PencilSquare, ChevronUp, ChevronDown, Trash } from 'react-bootstrap-icons';
import { doc, setDoc, collection, addDoc, getDocs } from "firebase/firestore"; 
import { db } from "../firebase/firebaseConfig";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const EditForm = () => {
    const navigate = useNavigate();
    const { formTitle } = useParams();

    const [formFields, setFormFields] = useState([]);
    const [editingField, setEditingField] = useState(null);
  
    const addField = (fieldType) => {
        const newField = {
          id: Date.now(), 
          type: fieldType,
          label: fieldType, 
          text: fieldType,
          placeholder: fieldType === "SingleLine" ? "Single Line" : "MultiLine" ? "Multi Line" : "",
          options: fieldType === "Dropdown" ? ["Option 1", "Option 2"] : [],
        };
        setFormFields((prevFields) => [...prevFields, newField]);
    };
    
    // Edit field properties
    const editField = (id, updatedField) => {
      setFormFields((prevFields) =>
        prevFields.map((field) => (field.id === id ? updatedField : field))
      );
    };
    
    const DeleteField = (field) => {
        let tempArr = [...formFields];
        
        for (let i = 0; i < tempArr.length; i++) {
            if (tempArr[i].id == field.id) {
                tempArr.splice(i, 1);
                setFormFields(tempArr);
                break; 
            }
        }
    };
    
    const MoveUp = (field) => {
        let tempArr = [...formFields];
    
        for (let i = 0; i < tempArr.length; i++) {
            if (tempArr[i].id === field.id) {
                if (i > 0) {
                    const removedItem = tempArr[i];
                    tempArr.splice(i, 1); 
                    tempArr.splice(i - 1, 0, removedItem); 
                    setFormFields(tempArr);
                }
                break; 
            }
        }
    };
    

    const MoveDown = (field) => {
        let tempArr = [...formFields];
        console.log(formFields)
    
        for (let i = 0; i < tempArr.length; i++) {
            if (tempArr[i].id === field.id) {
                if (i < tempArr.length - 1) {
                    const removedItem = tempArr[i];
                    tempArr.splice(i, 1); 
                    tempArr.splice(i + 1, 0, removedItem); 
                    setFormFields(tempArr);
                }
                break; 
            }
        }
    };
    
    const [formName, setFormName] = useState("");
    const [formDescription, setFormDescription] = useState("");

    const [formsData, setFormsData] = useState([]);

    useEffect(() => {
        const fetchFormsData = async() => {
            const querySnapshot = await getDocs(collection(db, "Forms"));
            const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            for (let key in documents) {
              if (documents.hasOwnProperty(key)) {
                if (documents[key].Title === formTitle) {
                    const querySnapshot2 = await getDocs(collection(db, `Forms/${documents[key].id}/Fields`));
                    const documents2 = querySnapshot2.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                    documents2.sort((a, b) => a.index - b.index);
                    setFormFields(documents2);
                    setFormName(documents[key].Title);
                    setFormDescription(documents[key].Subtitle);
                    setFormsData(documents[key]);
                }
              }
            }
        }

        fetchFormsData();
    }, []);

    const updateForm = async (e) => {
        e.currentTarget.innerHTML = "Updating Form...";
        e.target.style.cursor = "wait";
    
        var today = new Date();

        try {    
          await setDoc(doc(db, `Forms/${formsData.id}`), {
            Title: formName,
            Subtitle: formDescription,
            Created: today,
          });

          for (let i = 0; i < formFields.length; i++) {
            await setDoc(doc(db, `Forms/${formsData.id}/Fields/${formFields[i].id}`), {
              label: formFields[i].label,
              options: formFields[i].options,
              placeholder: formFields[i].placeholder,
              text: formFields[i].text,
              type: formFields[i].type,
              index: i
            });
          }
    
          console.log("Form successfully created!");
    
        } catch (error) {
          console.error("Error creating form: ", error);
        }
    
        navigate('/forms-builder');
    };
      
    return (
    <div id="content">
        <DndProvider backend={HTML5Backend}>
            <div className='row'>
                <div className='col-sm-9' id="form-preview">
                    <h1>Edit Form: {formTitle}</h1>
                    <div className='form-details'>
                        <input placeholder='Form Name' value={formName} onChange={(e) => setFormName(e.target.value)}/>
                        <input placeholder='Form Description' value={formDescription} onChange={(e) => setFormDescription(e.target.value)}/>
                    </div>
                    <hr/>
                    <h4>Form Preview</h4>
                    {formFields.map((field, index) => (
                        <div key={index} style={{ marginBottom: "10px" }} className='form-elements'>
                        {field.type === "Label" && (<><label>{field.text}</label>
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "SingleLine" && (<><input type="text" placeholder={field.placeholder} /> 
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "MultiLine" && (<><textarea placeholder={field.placeholder} />
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "RadioSelect" && (<><label><input type="radio"/> {field.label}</label>
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "Checkbox" && (<><label><input type="checkbox"/> {field.label}</label>
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "FileUpload" && (<><input type="file" placeholder={field.placeholder} />
                        <div className='editing-tools'>
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "Dropdown" && (<>
                            <select>
                                {field.Options.map((option, i) => (
                                    <option key={i}>{option}</option>
                                ))}
                            </select>
                            <div className='editing-tools'>
                                <PencilSquare onClick={() => setEditingField(field)}/> 
                                <ChevronUp onClick={() => MoveUp(field)}/>
                                <ChevronDown onClick={() => MoveDown(field)}/>
                                <Trash onClick={() => DeleteField(field)}/>
                            </div>
                            </>
                        )}
                        {/* {field.type === "Signature" && (<><input type="signature" placeholder={field.placeholder} />
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)} */}
                        {field.type === "Heading" && (<><h3>{field.text}</h3>
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "Divider" && (<><hr/>
                        <div className='editing-tools'>
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        {field.type === "Text" && (<><p>{field.text}</p>
                        <div className='editing-tools'>
                            <PencilSquare onClick={() => setEditingField(field)}/> 
                            <ChevronUp onClick={() => MoveUp(field)}/>
                            <ChevronDown onClick={() => MoveDown(field)}/>
                            <Trash onClick={() => DeleteField(field)}/>
                        </div>
                        </>)}
                        </div>
                    ))}
                    <DropArea addField={addField} />
                    {editingField && (
                        <FieldEditor field={editingField} editField={editField} setEditingField={setEditingField} />
                    )}
                    <br/>
                    <button onClick={(e) => updateForm(e)}>Update Form</button>
                </div>
                <div className='col-sm-3'>
                    <div id="toolbox" style={{ marginLeft: "20px" }}>
                        <h3>Toolbox</h3>
                        <div className='toolbox-items'>
                            <FormField fieldType="SingleLine" />
                            <FormField fieldType="MultiLine" />
                            <FormField fieldType="RadioSelect" />
                            <FormField fieldType="Checkbox" />
                            <FormField fieldType="FileUpload" />
                            <FormField fieldType="Dropdown" />
                            {/* <FormField fieldType="Signature" /> */}
                            <FormField fieldType="Heading" />
                            <FormField fieldType="Divider" />
                            <FormField fieldType="Text" />
                            <FormField fieldType="Label" />
                        </div>
                    </div>
                </div>
            </div>
        </DndProvider>
    </div>
    );
}

export default EditForm;
